// AddNewAttemptBonusPrice - стоимость ещё одной попытки отгадать слово
export const AddNewAttemptBonusPrice = 100;

// Add3DailyAttemptsBonusPrice - стоимость 3х дополнительных жизней
export const Add3DailyAttemptsBonusPrice = 449;

// UndoMoveBonusPrice - стоимость отмены последнего хода
export const UndoMoveBonusPrice = 50;

// TimeBoostHintPrice - стоимость подсказки, добавляющей время
export const TimeBoostHintPrice = 90;

// WordContourHintPrice - стоимость подсказки, показывающей контур слова
export const WordContourHintPrice = 120;
